<section class="hero-wrap hero-wrap-2"
    style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div
            class="row no-gutters slider-text align-items-center justify-content-center">

        </div>
    </div>
</section>

<section class="ftco-section bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row d-flex justify-content-center g-0">
                        <div class="col-lg-6">
                            <div class="contact-wrap w-100 wrap-content">
                                <h3>
                                  Change Password
                                </h3>
                                <form [formGroup]="changePasswordForm">
                                    <div class="row">
                                        <div class="col-md-12 mt-2">
                                            <div class="form-group">
                                              <input type="password"
                                                     class="form-control"
                                                     name="old_password"
                                                     placeholder="Old Password"
                                                     formControlName="old_password">
                                            </div>
                                            <ng-container *ngIf="myFormSubmit && formControls['old_password'].errors && formControls['old_password'].errors['required']">
                                              <div class="error-field">
                                                Old Password is required
                                              </div>
                                            </ng-container>
                                          </div>
                                          
                                          <div class="col-md-12 mt-3">
                                            <div class="form-group">
                                              <input type="password"
                                                     class="form-control"
                                                     name="new_password"
                                                     placeholder="New Password"
                                                     formControlName="new_password">
                                            </div>
                                            <ng-container *ngIf="myFormSubmit && formControls['new_password'].errors && formControls['new_password'].errors['required']">
                                              <div class="error-field">
                                                New Password is required
                                              </div>
                                            </ng-container>
                                          </div>
                                          
                                          <div class="col-md-12 mt-3">
                                            <div class="form-group">
                                              <input type="password"
                                                     class="form-control"
                                                     name="confirm_password"
                                                     placeholder="Re-Enter Confirm Password"
                                                     formControlName="confirm_password">
                                            </div>
                                            <ng-container *ngIf="myFormSubmit && formControls['confirm_password'].errors && formControls['confirm_password'].errors['required']">
                                              <div class="error-field">
                                                Confirm Password is required
                                              </div>
                                            </ng-container>
                                          </div>
                                          
                                    <div class="col-md-12 mt-1">
                                        <div class="form-group">
                                            <button type="button"
                                                (click)="onSubmit()"
                                                class="btn btn-primary">Submit</button>
                                        </div>
                                    </div>
                                    </div>
                                </form>
                                <!-- <div class="w-100 social-media mt-5">
                                    <h3>
                                      Follow us here
                                    </h3>
                                    <p>
                                        <a href="#">Facebook</a>
                                        <a href="#">Twitter</a>
                                        <a href="#">Instagram</a>
                                        <a href="#">Dribbble</a>
                                    </p>
                                </div> -->
                            </div>
                        </div>
                        <!-- <div class="col-lg-6 d-flex align-items-stretch">
                            <div id="map" class="bg-white"></div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
